import { z } from 'zod';

import { DeclarationStatus } from '@e-origin/shared';

const count = z.number().optional();
const ids = z.array(z.coerce.string()).optional();

export const BatchStatisticsInStatusSchema = z.object({
  status: z.nativeEnum(DeclarationStatus).optional(),
  total: count,
});

export const BatchStatisticsInFlowSchema = z.object({
  PRE: z.array(BatchStatisticsInStatusSchema).optional(),
  POST: z.array(BatchStatisticsInStatusSchema).optional(),
});

export const BatchStatisticsSchema = z.object({
  total: count,
  analysis: count,
  analysisIds: ids,
  notSent: count,
  notSentIds: ids,
  accepted: count,
  acceptedIds: ids,
  released: count,
  releasedIds: ids,
  exported: count,
  exportedIds: ids,
  rejected: count,
  rejectedIds: ids,
  notReleased: count,
  notReleasedIds: ids,
  inControl: count,
  inControlIds: ids,
  invalidationPending: count,
  invalidationPendingIds: ids,
  invalidated: count,
  invalidatedIds: ids,
  sending: count,
  sendingIds: ids,
  sent: count,
  beGateSent: count,
  beGateReleased: count,
  beGateNotReleased: count,
  sentIds: ids,
  analysisSplitShipment: count,
  analysisWrongValue: count,
  analysisWrongValueFixed: count,
  analysisWrongDescription: count,
  analysisWrongDescriptionFixed: count,
  analysisWrongHsCode: count,
  analysisWrongHsCodeFixed: count,
  analysisCountScraping: count,
  analysisCountAi: count,
  analysisCountScreenshots: count,
  recount: z.boolean().optional(),
  analysisUndervaluation: count,
  analysisIOSS: count,
  preSent: count,
  preInControl: count,
  preAccepted: count,
  in: BatchStatisticsInFlowSchema.optional(),
  actionsPending: count,
  notificationsPending: count,
  declarationGroups: count,
  regenerateCustomsReport: z.boolean().optional(),
});

export type BatchStatisticsDto = z.infer<typeof BatchStatisticsSchema>;
